<template>
    <div style="">
        <div style="display: flex;border-bottom: solid 1px #e6e6e6;margin-bottom: 20px;">
            <div style="flex: 1;margin-top:15px;margin-left: 15px;">
                <i @click="toggle(!collapsed)" v-if="!collapsed" style="font-size: 34px;" class="el-icon-s-fold"></i>
                <i @click="toggle(collapsed)" v-if="collapsed" style="font-size: 34px;" class="el-icon-s-unfold"></i>
            </div>

            <div style="display: flex;align-items: center;justify-content: center">
                <div>
                    <el-avatar :src="preview_path_url+userInfo.coverUrl"></el-avatar>
                </div>
                <div>
                    <el-menu style="border-bottom: 0;" default-active="2" class="el-menu-demo" mode="horizontal">
                        <el-submenu index="2">
                            <template slot="title">
                                {{ loginName }}
                            </template>
                            <el-menu-item @click="btnInfo" index="2-1">个人中心</el-menu-item>
                            <el-menu-item @click="logout" index="2-2">退出登录</el-menu-item>
                        </el-submenu>
                    </el-menu>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {removeLeftMenu, removeToken} from "@/utils/SessionStorage";
import Bus from "@/utils/Bus";
import global from "@/api/global";

export default {
    name: "Navigation",
    created() {
        this.loginName = sessionStorage.getItem("loginName");
    },
    data() {
        return {
            collapsed: false,
            loginName: "",
            userInfo: JSON.parse(sessionStorage.getItem("loginInfo")),
            preview_path_url: global.preview_path_url,
        }
    },
    mounted() {
        this.loginName = sessionStorage.getItem("loginName");
    },

    methods: {
        // 切换显示
        toggle(showtype) {
            this.collapsed = !this.collapsed
            Bus.$emit('collapsed', this.collapsed)
        },
        logout() {
            removeToken();
            removeLeftMenu();
            sessionStorage.removeItem("loginName");
            this.$router.push("/login");
        },
        btnInfo() {
            this.$router.push("/system/info");
        }
    }
}
</script>

<style scoped>
</style>
